import React, { FunctionComponent, ReactElement } from 'react';
import { useMedia } from 'react-media-match';
import { Product, Dimension } from '@/interfaces';
import { SetProduct } from '../types';
import { ModalSelectLayer } from '../ModalSelect';
import { useBasket } from '../../ProductContext';
import MobilePickerTiles from './layout.mobile';
import DesktopPickerTiles from './layout.desktop';

interface PickerTilesProps {
  product: Product;
  setProduct: SetProduct;
  highlightUnselectedDimension?: boolean;
  setHighlightUnselectedDimension?: (isHightlight: boolean) => void;
}

export const PickerTiles: FunctionComponent<PickerTilesProps> = ({
  product: { dimensions },
  setProduct,
  highlightUnselectedDimension = false,
  setHighlightUnselectedDimension = () => {},
}): ReactElement => {
  const isMobile = useMedia({
    desktop: false,
    mobile: true,
    tablet: false,
  });
  const { setRequestedSKU, setAddToBasketRequested } = useBasket();

  return (
    <>
      {isMobile ? (
        <>
          {dimensions.map(
            (dimension: Dimension) =>
              dimension.type !== 'INPUT' && (
                <MobilePickerTiles dimension={dimension} setProduct={setProduct} />
              ),
          )}
        </>
      ) : (
        <>
          {dimensions.map(
            (dimension: Dimension) =>
              dimension.type !== 'INPUT' && (
                <DesktopPickerTiles dimension={dimension} setProduct={setProduct} />
              ),
          )}
        </>
      )}
      {highlightUnselectedDimension && (
        <ModalSelectLayer
          dimension={[...dimensions].pop()} // get last element from dimensions
          setProduct={(prodId: string) => {
            setProduct(prodId);
            setHighlightUnselectedDimension(false);
            setRequestedSKU(prodId);
            setAddToBasketRequested(true);
          }}
          isModalOpen={highlightUnselectedDimension}
          testOnClose={() => setHighlightUnselectedDimension(false)}
        />
      )}
    </>
  );
};

export default PickerTiles;
